import moment from 'moment/moment';

export const START_DATE_PARAM = 'startDate';
export const END_DATE_PARAM = 'endDate';
const QUERY_DATE_FORMAT = 'YYYY-MM-DD';

export type AccountUsageDateRange = { startDate: Date; endDate: Date };

// Metrics are bucketed by UTC day on the backend, so the whole range pipeline
// (presets, fetch, chart ticks, URL, picker label) works in UTC. Using local
// time here would shift the day for users in non-UTC zones and desync the
// query/label from the UTC ticks the chart draws.
export const defaultAccountUsageRange = (): AccountUsageDateRange => ({
  startDate: moment.utc().startOf('month').toDate(),
  endDate: moment.utc().startOf('day').toDate(),
});

export function parseAccountUsageDateRange(search: string): AccountUsageDateRange {
  const params = new URLSearchParams(search);
  const rawStart = params.get(START_DATE_PARAM);
  const rawEnd = params.get(END_DATE_PARAM);
  if (!rawStart || !rawEnd) return defaultAccountUsageRange();

  const start = moment.utc(rawStart, QUERY_DATE_FORMAT, true);
  const end = moment.utc(rawEnd, QUERY_DATE_FORMAT, true);
  if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) {
    return defaultAccountUsageRange();
  }

  const now = moment.utc();
  const clampedEnd = end.isAfter(now, 'day') ? now.startOf('day') : end;
  return { startDate: start.toDate(), endDate: clampedEnd.toDate() };
}

export function buildAccountUsageQuery(range: AccountUsageDateRange): string {
  const params = new URLSearchParams({
    [START_DATE_PARAM]: moment.utc(range.startDate).format(QUERY_DATE_FORMAT),
    [END_DATE_PARAM]: moment.utc(range.endDate).format(QUERY_DATE_FORMAT),
  });
  return params.toString();
}
